import { AbsolutePosition, DataObjectService } from '@openhps/core';
export class SymbolicSpaceService extends DataObjectService {
    constructor(dataServiceDriver) {
        super(dataServiceDriver);
    }
    findChildren(space) {
        return new Promise((resolve, reject) => {
            this.findAll({
                parentUID: space.uid,
            })
                .then(resolve)
                .catch(reject);
        });
    }
    findByPosition(position) {
        return new Promise((resolve, reject) => {
            this.findSymbolicSpaces(position)
                .then((responses) => {
                return resolve(responses.map((r) => r[0]));
            })
                .catch(reject);
        });
    }
    findSymbolicSpaces(positionOrType) {
        return new Promise((resolve, reject) => {
            if (positionOrType instanceof AbsolutePosition) {
                const position = positionOrType;
                this.findAll()
                    .then((results) => {
                    resolve(results
                        .map((res) => {
                        if (res.parentUID) {
                            const parent = results.filter((r) => r.uid === res.parentUID);
                            res.parent = parent.length > 0 ? parent[0] : undefined;
                        }
                        return res;
                    })
                        .filter((res) => res.isInside(position))
                        .sort((a, b) => b.priority - a.priority)
                        .map((res) => [res, res.priority]));
                })
                    .catch(reject);
            }
            else {
                const type = positionOrType;
                this.findAll()
                    .then((results) => {
                    resolve(results.filter((res) => res instanceof type).map((res) => [res, -1]));
                })
                    .catch(reject);
            }
        });
    }
}
//# sourceMappingURL=SymbolicSpaceService.js.map